import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const headerStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        main: {
            minHeight: "62px",
            maxHeight: "62px",
        },
        customClass: {
            margin: "0px 10px 0px 0px !important",
            width: "150px !important",
        },
        customInputClass: {
            width: "150px",
            height: "30px",
        },
        customLabelClass: {
            fontSize: "14px",
            fontWeight: 400,
            padding: "0px",
            margin: "0px",
            height: "20px",
        },
        search: {
            position: "relative",
            marginRight: theme.spacing(2),
            [theme.breakpoints.up("sm")]: {
                marginLeft: theme.spacing(0),
                width: "auto",
            },
            border: "1px solid #E8E8E8 !important",
            paddingBottom: "5px",
            paddingLeft: "12px",
        },

        profileButton: {
            backgroundColor: "#4FC3F7",
            borderRadius: theme.shape.borderRadius,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: 500,
            fontSize: "20px",
            lineHeight: "20px",
            minWidth: "32px",
            height: "32px",
        },
        userEmail: { color: "rgba(0, 0, 0, 0.38)" },
        userName: { color: "black", marginRight: "20px" },

        customerDropdown: {
            width: "400px",
        },
    })
);
